import styled, { css } from 'styled-components';

export const BusinessPageFormCategoryModal = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.palette.primary.background};
  padding: 5px 0 calc(env(safe-area-inset-bottom) + 90px);
  overflow: auto;
  width: 100%;
  height: 100%;
  max-height: 90vh;
  position: relative;
`;

export const BusinessPageFormCategoryInput = styled.input`
  display: none;
`;

export const ModalContent = styled.div`
  font-size: 16px;
  font-weight: 500;
  padding: 20px;
  text-align: center;
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary.border};
  position: relative;
  &::after {
    content: '*';
    color: ${({ theme }) => theme.palette.brand.main};
    font-size: 14px;
    font-weight: 400;
    margin-left: 3px;
  }
`;

export const ModalCloseButton = styled.div<{
  $categoryModal?: boolean;
}>`
  position: absolute;
  right: 0;
  top: 0;
  width: 45px;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 15px;
  background-image: url('/images/business/close.png');
  ${({ $categoryModal }) =>
    $categoryModal &&
    css`
      right: 40px;
    `}
`;

export const BusinessPageFormCategoryImage = styled.div`
  display: flex;
  align-items: center;
  width: 40px;
  height: 40px;
  z-index: 1;
  cursor: pointer;
  padding: 7px;
  background-color: ${({ theme }) => theme.palette.secondary.background};
  border-radius: 10px;
  margin-right: 15px;

  img {
    object-fit: contain;
  }
`;

export const BusinessPageFormCategoryCheckbox = styled.span<{
  $checked?: boolean;
  $categoryModal?: boolean;
}>`
  position: absolute;
  right: 25px;
  height: 20px;
  width: 20px;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.palette.primary.border};
  background: ${({ theme }) => theme.palette.primary.background};
  ${({ $checked }) =>
    $checked &&
    css`
      background-image: url('/images/business/selected.svg');
      border: none;
      background-position: center;
    `}
  ${({ $categoryModal }) =>
    $categoryModal &&
    css`
      right: 40px;
    `}
`;

export const BusinessPageFormCategoryLabel = styled.label<{
  $checked?: boolean;
  $categoryModal?: boolean;
}>`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  z-index: 1;
  cursor: pointer;
  user-select: none;
  margin-bottom: 5px;
  padding: 15px 10px;
  top: 0;
  font-size: 16px;
  font-weight: 400;
  &:hover {
    color: ${({ theme }) => theme.palette.brand.main};
    background: ${({ theme }) => theme.palette.secondary.background};
    border-radius: 14px;
  }
  ${({ $checked }) =>
    $checked &&
    css`
      color: ${({ theme }) => theme.palette.brand.main};
    `}
  ${({ $categoryModal }) =>
    $categoryModal &&
    css`
      padding: 10px 30px;
    `}
`;

export const BusinessPageFormModal = styled.div<{
  $showModal?: boolean;
}>`
  display: none;
  flex-direction: column;
  position: absolute;
  border-radius: 14px;
  border: 1px solid ${({ theme }) => theme.palette.primary.border};
  background: ${({ theme }) => theme.palette.primary.background};
  padding: 5px 10px 10px;
  max-height: 279px;
  overflow: auto;
  width: 100%;
  top: 65px;
  z-index: 2;
  ${({ $showModal }) =>
    $showModal &&
    css`
      display: flex;
    `}
`;

export const BusinessPageFormCategoryButton = styled.button`
  display: block;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  width: calc(100% - 30px);
  bottom: calc(env(safe-area-inset-bottom) + 10px);
  padding: 17px 35px;
  border-radius: 14px;
  background: ${({ theme }) => theme.palette.brand.main};
  border: 0;
  color: ${({ theme }) => theme.palette.primary.background};
  text-align: center;
  z-index: 5;
  font-size: 16px;
`;
